// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-search-header {
  font-size: 23px;
  font-weight: 700;
  font-family: Montserrat;
}
.request-sub-text {
  font-size: 16px;
  font-weight: 400;
  color: #5b5e5d;
}
.request-campaignname {
  font-size: 19px;
  font-weight: 500;
  color: #0a0f0d;
}
.request-campaignname-value {
  font-size: 16px;
  font-weight: 400;
  color: #5b5e5d;
}
.request-external-search-sve-btn {
  background-color: #d2042d;
  height: 40px;
  width: 90px;
  border: none;
}

.request-external-search-sve-btn:hover {
  background-color: #d2042d !important;
  height: 40px;
  width: 90px;
  border: none;
}
.submit-txt {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/view-rfp-modal/RequestExternalSearch.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".request-search-header {\n  font-size: 23px;\n  font-weight: 700;\n  font-family: Montserrat;\n}\n.request-sub-text {\n  font-size: 16px;\n  font-weight: 400;\n  color: #5b5e5d;\n}\n.request-campaignname {\n  font-size: 19px;\n  font-weight: 500;\n  color: #0a0f0d;\n}\n.request-campaignname-value {\n  font-size: 16px;\n  font-weight: 400;\n  color: #5b5e5d;\n}\n.request-external-search-sve-btn {\n  background-color: #d2042d;\n  height: 40px;\n  width: 90px;\n  border: none;\n}\n\n.request-external-search-sve-btn:hover {\n  background-color: #d2042d !important;\n  height: 40px;\n  width: 90px;\n  border: none;\n}\n.submit-txt {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
